import { TransactionQuickEntryModel } from "./transaction-quick-entry-model";

export class ExpenseQuickEntryModel {

    public ExpenseQuickEntryID: number;
    public ExpenseQuickEntryName: string;
    public ExpenseQuickEntryFullName: string;

    public CategoryID: number;
    public CategoryName: string;
public TransactionQuickEntryModel: TransactionQuickEntryModel[];
    constructor(
        id: number,
        name: string,
        fullName: string,
        categoryID: number,
        categoryName: string
    ) {
        this.ExpenseQuickEntryID = id;
        this.ExpenseQuickEntryName = name;
        this.ExpenseQuickEntryFullName = fullName;
        this.CategoryID = categoryID;
        this.CategoryName = categoryName;
        this.TransactionQuickEntryModel = [];
    }
static createNew(): ExpenseQuickEntryModel {
    return new ExpenseQuickEntryModel(
        0,
        '',
        '',
        0,
        ''
    );
}
    static getQuickEntries(): ExpenseQuickEntryModel[] {
        return [
            new ExpenseQuickEntryModel(
                1,
                'InstamartFoodExDrSwiggyCr',
                'Instamart Food Exp. Swiggy Cr',
                1,
                'Food'
            ),

            new ExpenseQuickEntryModel(
                2,
                'SwiggyRestroExDrSwiggyCr',
                'Swiggy Restro Exp. Swiggy Cr',
                1,
                'Food'
            ),

            new ExpenseQuickEntryModel(
                6,
                'AmazonFoodExDrAmazon2008Cr',
                'Amazon Food Exp. Amazon 2008 Cr',
                1,
                'Food'
            ),

            new ExpenseQuickEntryModel(
                3,
                'CredRegaliax2266DrTempCrViaICICI',
                'Cred Regaliax2266DrTempCr Via ICICI',
                2,
                'Credit Card'
            ),

            new ExpenseQuickEntryModel(
                4,
                'CredSwiggyx6479DrTempCrViaICICI',
                'Cred Swiggyx6479Dr TempCr Via ICICI',
                2,
                'Credit Card'
            ),

            new ExpenseQuickEntryModel(
                5,
                'CredAmazonICICx2008DrTempCrViaICICI',
                'Cred AmazonICICx20089Dr TempCr Via ICICI',
                2,
                'Credit Card'
            )
        ];
    }
}